import clsx from 'clsx';
import React, { FunctionComponent } from 'react';
import { formatOverviewTagLabel } from '../../clientOverviewUtils';
import styles from './ClientOverviewHeader.module.scss';

interface ClientOverviewHeaderProps {
    clientName: string;
    createdAt: string;
    tags: string[];
}

export const ClientOverviewHeader: FunctionComponent<ClientOverviewHeaderProps> = props => {
    const hasTags = props.tags.length > 0;

    return (
        <div className={styles.header}>
            <h1 className={styles.clientName}>{props.clientName}</h1>
            <p className={clsx(styles.createdAt, hasTags && styles.createdAtWithTags)}>{props.createdAt}</p>
            {hasTags && (
                <div className={styles.tags}>
                    {props.tags.map(tag => (
                        <span
                            key={tag}
                            className={styles.tag}
                        >
                            {formatOverviewTagLabel(tag)}
                        </span>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ClientOverviewHeader;
